/**
 * Lightweight confetti — no library, just emoji burst from a click point.
 * Usage: confettiBurst({x, y}, '🎉')
 */

export function confettiBurst(
  origin: { x: number; y: number },
  emoji: string = '🎉',
  count: number = 14,
): void {
  if (typeof document === 'undefined') return;

  for (let i = 0; i < count; i++) {
    const particle = document.createElement('div');
    particle.textContent = emoji;
    particle.style.cssText = `
      position: fixed;
      left: ${origin.x}px;
      top: ${origin.y}px;
      font-size: ${18 + Math.random() * 14}px;
      pointer-events: none;
      z-index: 9999;
      user-select: none;
      transition: transform 1100ms cubic-bezier(0.16, 1, 0.3, 1), opacity 1100ms ease-out;
    `;
    document.body.appendChild(particle);

    // Force reflow then animate
    requestAnimationFrame(() => {
      const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.5;
      const distance = 80 + Math.random() * 80;
      const tx = Math.cos(angle) * distance;
      const ty = Math.sin(angle) * distance - 40; // bias upward
      const rot = (Math.random() - 0.5) * 720;
      particle.style.transform = `translate(${tx}px, ${ty}px) rotate(${rot}deg) scale(${0.6 + Math.random() * 0.6})`;
      particle.style.opacity = '0';
    });

    setTimeout(() => particle.remove(), 1200);
  }
}
